import { FC } from 'react'
import { WidgetSection } from 'modules/Cube/view/common/atomic/WidgetSection'
import {
  CustomFieldsEditor,
  GreyGrey10,
  InputSelectControlField,
  TextInputField,
  Box,
  Flex
} from '@sequencehq/core-components'
import { useAdditionalInformationWidget } from 'modules/Cube/view/layouts/billingSchedule/widgets/AdditionalInformation/useAdditionalInformationWidget'
import { ScheduleCustomField } from 'modules/Cube/domain/cube.domain.types'

export const AdditionalInformationWidget: FC = () => {
  const { fieldsConfig } = useAdditionalInformationWidget()

  return (
    <WidgetSection title="Additional information" width="100%">
      <Box padding="0 16px 20px" data-testid="schedule.additionalInformation">
        <Box
          padding="12px 8px 12px"
          backgroundColor={GreyGrey10}
          borderRadius="6px"
        >
          {/* fit-content so the trimmed-fields VRT clips to the fields, not the
              full-width widget/grey container. */}
          <Box
            as={Flex}
            flexDirection="column"
            gap="16px"
            width="fit-content"
            data-testid="schedule.additionalInformation.fields"
          >
            {!fieldsConfig.taxRate.hidden && (
              <Flex width="235px">
                <InputSelectControlField
                  data-testid="additional.taxRate"
                  label="Tax"
                  placeholder="Select tax rate"
                  options={fieldsConfig.taxRate.options}
                  onChange={fieldsConfig.taxRate.onChange}
                  disabled={fieldsConfig.taxRate.disabled}
                  initialValue={fieldsConfig.taxRate.value}
                  validationErrors={fieldsConfig.taxRate.validationErrors}
                  matchWidth
                />
              </Flex>
            )}

            {!fieldsConfig.label.hidden && (
              <TextInputField
                label="Label"
                placeholder="Optional label"
                {...fieldsConfig.label}
                onChange={event =>
                  fieldsConfig.label.onChange(event?.target?.value)
                }
                width="235px"
              />
            )}
            <CustomFieldsEditor<ScheduleCustomField>
              fields={fieldsConfig.customFields.value}
              onAdd={fieldsConfig.customFields.onAdd}
              onRemove={fieldsConfig.customFields.onRemove}
              disabled={fieldsConfig.customFields.disabled}
              title="Custom fields"
              addButtonLabel="Add custom field"
              addButtonVariant="inline"
              width="470px"
              data-testid="additional.customFields"
              renderCells={(field, siblingFields, index) => (
                <CustomFieldsEditor.Row
                  keyValue={field.key}
                  siblingFields={siblingFields}
                  onKeyChange={next =>
                    fieldsConfig.customFields.onUpdate(field.id, { key: next })
                  }
                  keyOptions={fieldsConfig.customFields.keyOptions}
                  value={field.value}
                  onValueChange={next =>
                    fieldsConfig.customFields.onUpdate(field.id, {
                      value: next
                    })
                  }
                  disabled={fieldsConfig.customFields.disabled}
                  testIdPrefix={`additional.customFields.row.${index}`}
                />
              )}
            />
          </Box>
        </Box>
      </Box>
    </WidgetSection>
  )
}
